/**
 * Prepopulated release calendar events for 2026 (from release calendar screenshot).
 * Used so the calendar always shows data even before seed script is run.
 * Format: { 'YYYY-MM-DD': eventType }
 */
export const PREPOPULATED_2026 = {
  // January
  '2026-01-07': 'maintenance_dev_freeze',
  '2026-01-13': 'maintenance_release',
  '2026-01-29': 'maintenance_release',
  '2026-01-01': 'weekend_holiday',
  '2026-01-02': 'weekend_holiday',
  '2026-01-03': 'weekend_holiday',
  '2026-01-04': 'weekend_holiday',
  '2026-01-10': 'weekend_holiday',
  '2026-01-11': 'weekend_holiday',
  '2026-01-17': 'weekend_holiday',
  '2026-01-18': 'weekend_holiday',
  '2026-01-24': 'weekend_holiday',
  '2026-01-25': 'weekend_holiday',
  '2026-01-31': 'weekend_holiday',
  // February
  '2026-02-05': 'maintenance_dev_freeze',
  '2026-02-19': 'maintenance_dev_freeze',
  '2026-02-11': 'maintenance_release',
  '2026-02-25': 'maintenance_release',
  '2026-02-20': 'pm_signoff',
  '2026-02-27': 'feature_dev_freeze',
  '2026-02-01': 'weekend_holiday',
  '2026-02-02': 'weekend_holiday',
  '2026-02-08': 'weekend_holiday',
  '2026-02-09': 'weekend_holiday',
  '2026-02-14': 'weekend_holiday',
  '2026-02-15': 'weekend_holiday',
  '2026-02-22': 'weekend_holiday',
  '2026-02-28': 'weekend_holiday',
  // March - per screenshot: Purple 4, 19; Red 10, 24; Green 11; Yellow 21; Brown 8,15,22,29; Grey 1,2,7,14,28,30,31
  '2026-03-04': 'maintenance_dev_freeze',
  '2026-03-19': 'maintenance_dev_freeze',
  '2026-03-10': 'maintenance_release',
  '2026-03-24': 'maintenance_release',
  '2026-03-11': 'feature_release',
  '2026-03-21': 'pm_signoff',
  '2026-03-08': 'deployment_weekend',
  '2026-03-15': 'deployment_weekend',
  '2026-03-22': 'deployment_weekend',
  '2026-03-29': 'deployment_weekend',
  '2026-03-01': 'weekend_holiday',
  '2026-03-02': 'weekend_holiday',
  '2026-03-07': 'weekend_holiday',
  '2026-03-14': 'weekend_holiday',
  '2026-03-28': 'weekend_holiday',
  '2026-03-30': 'weekend_holiday',
  '2026-03-31': 'weekend_holiday',
  // April - Purple 2, 16, 23; Red 8, 22; Grey 4,5,11,12,18,19,25,26
  '2026-04-02': 'maintenance_dev_freeze',
  '2026-04-16': 'maintenance_dev_freeze',
  '2026-04-23': 'maintenance_dev_freeze',
  '2026-04-08': 'maintenance_release',
  '2026-04-22': 'maintenance_release',
  '2026-04-04': 'weekend_holiday',
  '2026-04-05': 'weekend_holiday',
  '2026-04-11': 'weekend_holiday',
  '2026-04-12': 'weekend_holiday',
  '2026-04-18': 'weekend_holiday',
  '2026-04-19': 'weekend_holiday',
  '2026-04-25': 'weekend_holiday',
  '2026-04-26': 'weekend_holiday',
  // May - Red 6, 20; Purple 14; Yellow 22; Dark Blue 29; Grey 2,3,9,10,16,17,23,24,30,31
  '2026-05-06': 'maintenance_release',
  '2026-05-20': 'maintenance_release',
  '2026-05-14': 'maintenance_dev_freeze',
  '2026-05-22': 'pm_signoff',
  '2026-05-29': 'feature_dev_freeze',
  '2026-05-02': 'weekend_holiday',
  '2026-05-03': 'weekend_holiday',
  '2026-05-09': 'weekend_holiday',
  '2026-05-10': 'weekend_holiday',
  '2026-05-16': 'weekend_holiday',
  '2026-05-17': 'weekend_holiday',
  '2026-05-23': 'weekend_holiday',
  '2026-05-24': 'weekend_holiday',
  '2026-05-30': 'weekend_holiday',
  '2026-05-31': 'weekend_holiday',
  // June - Green 10; Purple 18; Red 24; Brown 7,14,21,28; Grey 6,13,20,27
  '2026-06-10': 'feature_release',
  '2026-06-18': 'maintenance_dev_freeze',
  '2026-06-24': 'maintenance_release',
  '2026-06-07': 'deployment_weekend',
  '2026-06-14': 'deployment_weekend',
  '2026-06-21': 'deployment_weekend',
  '2026-06-28': 'deployment_weekend',
  '2026-06-06': 'weekend_holiday',
  '2026-06-13': 'weekend_holiday',
  '2026-06-20': 'weekend_holiday',
  '2026-06-27': 'weekend_holiday',
  // July - Purple 2, 16; Red 8, 22; Grey 4,5,11,12,18,19,25,26
  '2026-07-02': 'maintenance_dev_freeze',
  '2026-07-16': 'maintenance_dev_freeze',
  '2026-07-08': 'maintenance_release',
  '2026-07-22': 'maintenance_release',
  '2026-07-04': 'weekend_holiday',
  '2026-07-05': 'weekend_holiday',
  '2026-07-11': 'weekend_holiday',
  '2026-07-12': 'weekend_holiday',
  '2026-07-18': 'weekend_holiday',
  '2026-07-19': 'weekend_holiday',
  '2026-07-25': 'weekend_holiday',
  '2026-07-26': 'weekend_holiday',
  // August - Red 5, 19; Purple 13; Yellow 21; Dark Blue 28; Grey 1,2,8,9,15,16,22,23,29,30,31
  '2026-08-05': 'maintenance_release',
  '2026-08-19': 'maintenance_release',
  '2026-08-13': 'maintenance_dev_freeze',
  '2026-08-21': 'pm_signoff',
  '2026-08-28': 'feature_dev_freeze',
  '2026-08-01': 'weekend_holiday',
  '2026-08-02': 'weekend_holiday',
  '2026-08-08': 'weekend_holiday',
  '2026-08-09': 'weekend_holiday',
  '2026-08-15': 'weekend_holiday',
  '2026-08-16': 'weekend_holiday',
  '2026-08-22': 'weekend_holiday',
  '2026-08-23': 'weekend_holiday',
  '2026-08-29': 'weekend_holiday',
  '2026-08-30': 'weekend_holiday',
  '2026-08-31': 'weekend_holiday',
  // September - Green 9, 23; Purple 17; Red 24; Brown 6,13,20,27; Grey 5,12,19,26
  '2026-09-09': 'feature_release',
  '2026-09-23': 'feature_release',
  '2026-09-17': 'maintenance_dev_freeze',
  '2026-09-24': 'maintenance_release',
  '2026-09-06': 'deployment_weekend',
  '2026-09-13': 'deployment_weekend',
  '2026-09-20': 'deployment_weekend',
  '2026-09-27': 'deployment_weekend',
  '2026-09-05': 'weekend_holiday',
  '2026-09-12': 'weekend_holiday',
  '2026-09-19': 'weekend_holiday',
  '2026-09-26': 'weekend_holiday',
  // October - Purple 1, 15; Red 7, 21; Yellow 30; Grey 3,4,10,11,17,18,24,25,31
  '2026-10-01': 'maintenance_dev_freeze',
  '2026-10-15': 'maintenance_dev_freeze',
  '2026-10-07': 'maintenance_release',
  '2026-10-21': 'maintenance_release',
  '2026-10-30': 'pm_signoff',
  '2026-10-03': 'weekend_holiday',
  '2026-10-04': 'weekend_holiday',
  '2026-10-10': 'weekend_holiday',
  '2026-10-11': 'weekend_holiday',
  '2026-10-17': 'weekend_holiday',
  '2026-10-18': 'weekend_holiday',
  '2026-10-24': 'weekend_holiday',
  '2026-10-25': 'weekend_holiday',
  '2026-10-31': 'weekend_holiday',
  // November - Dark Blue 5; Green 18; Yellow 24; Brown 22, 29; Grey 1,7,8,14,15,21,28
  '2026-11-05': 'feature_dev_freeze',
  '2026-11-18': 'feature_release',
  '2026-11-24': 'pm_signoff',
  '2026-11-22': 'deployment_weekend',
  '2026-11-29': 'deployment_weekend',
  '2026-11-01': 'weekend_holiday',
  '2026-11-07': 'weekend_holiday',
  '2026-11-08': 'weekend_holiday',
  '2026-11-14': 'weekend_holiday',
  '2026-11-15': 'weekend_holiday',
  '2026-11-21': 'weekend_holiday',
  '2026-11-28': 'weekend_holiday',
  // December - Brown 6, 13; Yellow 4, 11; Grey 5,12,19,20,25,26,27
  '2026-12-06': 'deployment_weekend',
  '2026-12-13': 'deployment_weekend',
  '2026-12-04': 'pm_signoff',
  '2026-12-11': 'pm_signoff',
  '2026-12-05': 'weekend_holiday',
  '2026-12-12': 'weekend_holiday',
  '2026-12-19': 'weekend_holiday',
  '2026-12-20': 'weekend_holiday',
  '2026-12-25': 'weekend_holiday',
  '2026-12-26': 'weekend_holiday',
  '2026-12-27': 'weekend_holiday'
};
